import { z } from 'zod'

export const baseResponseSchema = z.object(
  {
    data: z.any({
      message: 'Falta el objeto data en el root  de la respuesta'
    }),
    message: z.string({
      message: 'Falta el mensaje en el root de la respuesta'
    })
  },
  { message: 'El root de la respuesta debería ser un objeto' }
)
